import apiClient from '../helpers/apiClient'

// WP-X5 "Book an Expert" discovery — READ endpoints for the expert directory (X1 ExpertProfile).
// Aligned to X4's real ExpertProfilePublicSerializer (ExpertBrowseView / ExpertDetailView).
// BLOCKED on X4 deploy; callers degrade gracefully (empty / error state) so the screen renders and
// only the network action fails until X4 is live.
//
// Contract (camelCased by djangorestframework_camel_case), same public serializer for list + detail:
//   GET /api/v1/expertise/experts/?area=<catalogId>&search=<q>&limit=&offset=
//     -> { count, next, previous, results: [Expert] }   (listed + active only; search on headline/bio)
//   GET /api/v1/expertise/experts/<id>/  -> Expert
//
//   Expert = { id, ownerType: 'member' | 'partner', displayName, headline, bio,
//              listedRate: number|null, currency: string|null, rateType: string|null,
//              availabilityNote: string|null, expertiseAreas: [{ id, name }] }

export interface ExpertListParams {
  area?: string | number
  search?: string
  limit?: number
  offset?: number
}

const EXPERTS_URL = '/expertise/experts/'

export const getExperts = async (params: ExpertListParams = {}) => {
  const response = await apiClient.get(EXPERTS_URL, {params})
  return response.data
}

export const getExpertDetail = async (id: number | string) => {
  const response = await apiClient.get(`${EXPERTS_URL}${id}/`)
  return response.data
}
